import React, { VFC }  from 'react';

const ErrorWithMessage: VFC<{ title: string; message: string }> = ({ title, message }) => (
    <div>
        <div>
            <strong>{title}</strong>
        </div>
        {message.split('\n').map((e, i) => (
            <div key={i}>{e}</div>
        ))}
    </div>
);

export default ErrorWithMessage;